import React from "react";
import MessageActivityDetailsMessageInfo from "../messageInfo/messageInfo";
import MessageActivityDetailsRecipientInfo from "../recipientInfo/recipientInfo";
import { Card } from "@shared/ui/card";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import MessageActivityDetailsMessageContent from "../messageContent/messageContent";
import { useGetMessageActivityById } from "../../hooks";

const MessageActivityDetailsLanding = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: messageActivityData } = useGetMessageActivityById(id);
  return (
    <div className="space-y-6 p-1">
      <div className="flex items-center gap-4">
        {/* Back Arrow */}
        <ArrowLeft
          className="w-5 h-5 cursor-pointer text-gray-700"
          onClick={() => navigate("/communication-hub/message-activity")}
        />

        {/* Page Header */}
        <div className="flex flex-col">
          <PageHeader
            title="View Message Activity"
            subtitle="Track performance and progress of your message activity"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">
        <Card className="p-2 col-span-4">
          <MessageActivityDetailsRecipientInfo data={messageActivityData} />
        </Card>
        <Card className="p-2 col-span-8">
          <MessageActivityDetailsMessageInfo data={messageActivityData} />
        </Card>
      </div>
      <Card className="p-2">
        <MessageActivityDetailsMessageContent data={messageActivityData} />
      </Card>
    </div>
  );
};

export default MessageActivityDetailsLanding;
